if (!window?.jQuery?.param) {
    window.jQuery ??= function () {
        console.warn('jQuery is unavailable; this is a stub.');
        return [];
    };

    /**
     * Polyfill for {@link https://api.jquery.com/jQuery.param/ jQuery.param()}
     * required by Hitit IBE JS Search API.
     */
    window.jQuery.param ??= function (a) {
        const s = [];
        const add = function (k, v) {
            v = typeof v === 'function' ? v() : v;
            v = v === null ? '' : v === undefined ? '' : v;
            s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
        };

        const buildParams = function (prefix, obj) {
            let i, len, key;

            if (prefix) {
                if (Array.isArray(obj)) {
                    for (i = 0, len = obj.length; i < len; i++) {
                        buildParams(
                            prefix + '[' + (typeof obj[i] === 'object' && obj[i] ? i : '') + ']',
                            obj[i]
                        );
                    }
                } else if (Object.prototype.toString.call(obj) === '[object Object]') {
                    for (key in obj) {
                        buildParams(prefix + '[' + key + ']', obj[key]);
                    }
                } else {
                    add(prefix, obj);
                }
            } else if (Array.isArray(obj)) {
                for (i = 0, len = obj.length; i < len; i++) {
                    add(obj[i].name, obj[i].value);
                }
            } else {
                for (key in obj) {
                    buildParams(key, obj[key]);
                }
            }

            return s;
        };

        return buildParams('', a).join('&');
    };
}

if (!String.prototype.capitalize) {
    String.prototype.capitalize = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    };
}

if (!RegExp.escape) {
    /**
     * Quote regular expression characters.
     *
     * @param  {String} str - The input string.
     * @return {String} Returns the quoted (escaped) string.
     */
    RegExp.escape = function (str) {
        return str.replace(/[\-\[\\\]\{\}\(\)\*\+\?\.\,\\\^\$|#\s]/g, '\\$&');
    };
}

/**
 * Element.prototype.closest
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#polyfill
 */
if (window.Element) {
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        if (Element.prototype.matches) {
            /**
             * For browsers that support `element.matches()`
             * (or a prefixed equivalent, meaning IE9+):
             */
            Element.prototype.closest = function (selectors) {
                var el = this;

                do {
                    if (Element.prototype.matches.call(el, selectors)) return el;
                    el = el.parentElement || el.parentNode;
                } while (el !== null && el.nodeType === 1);

                return null;
            };
        } else {
            /**
             * For IE 8 support:
             */
            Element.prototype.closest = function (selectors) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(selectors),
                    i,
                    el = this;

                do {
                    i = matches.length;
                    while (--i >= 0 && matches.item(i) !== el) {};
                } while ((i < 0) && (el = el.parentElement));

                return el;
            };
        }
    }
}
